import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    CARD: 'Card',
    CASH_DEPOSIT: 'Cash Deposit',
    CHECK: 'Check',
    DIRECT_DEBIT: 'Direct debit',
    INSTANT_TRANSFER: 'Instant transfer',
    INTERNATIONAL_TRANSFER: 'International transfer',
    INTRA_COMPANY_FUNDS_TRANSFER: 'Internal transfer',
    SWIFT_TRANSFER: 'International transfer',
    TRANSFER: 'Standard transfer',
    WALLET_TRANSFER: 'Transfer',
  },
  fr: {
    CARD: 'Carte',
    CASH_DEPOSIT: 'Dépôt d’espèces',
    CHECK: 'Chèque',
    DIRECT_DEBIT: 'Prélèvement',
    INSTANT_TRANSFER: 'Virement instantané',
    INTERNATIONAL_TRANSFER: 'Virement international',
    INTRA_COMPANY_FUNDS_TRANSFER: 'Virement interne',
    SWIFT_TRANSFER: 'Virement international',
    TRANSFER: 'Virement standard',
    WALLET_TRANSFER: 'Virement',
  },
} as const);

export default locales;
